import * as api from 'config/axios';
import * as endpoints from './endpoints';
import { getToken } from 'utils/common/session';

const getRenewalNotificationReqOptions = () => {
  const accessToken = getToken();

  let options = {
    headers: {
      Authorization: 'Bearer ' + accessToken,
    },
  };

  return options;
};

export const getRenewalNotificationService = () => {
  const options = getRenewalNotificationReqOptions();
  return api.sendGet(endpoints.GET_USER_RENEWAL_NOTIFICATION, options);
};

export const acceptRenewalNotificationService = (renewalNotificationId) => {
  const data = {
    renewalNotificationId,
  };
  const options = getRenewalNotificationReqOptions();
  return api.sendPost(endpoints.ACCEPT_RENEWAL_NOTIFICATION, data, options);
};

export const createRenewalNotification = (data) => {
  return api.sendPost(endpoints.CREATE_RENEWAL_NOTIFICATION, data);
};

export const cloneRenewalNotification = (data) => {
  return api.sendPost(endpoints.CLONE_RENEWAL_NOTIFICATION, data);
};

export const deleteRenewalNotification = (data) => {
  return api.sendPost(endpoints.DELETE_RENEWAL_NOTIFICATION, data);
};

export const getRenewalNotificationShortContent = (data) => {
  return api.sendPost(endpoints.GET_RENEWAL_NOTIFICATION_SHORT_CONTENT, data);
};

export const getRenewalNotificationGrid = () => {
  return api.sendGet(endpoints.GET_RENEWAL_NOTIFICATION_GRID);
};

export const exportRenewalNotificationAcceptedUsers = (params) => {
  return api.sendPost(
    endpoints.EXPORT_RENEWAL_NOTIFICATION_ACCEPTED_USERS,
    params
  );
};

export const getRenewalNotificationGridDistinct = () => {
  return api.sendGet(endpoints.GET_RENEWAL_NOTIFICATION_GRID_DISTINCT);
};

export const getRenewalNotificationAcceptedUsersGrid = () => {
  return api.sendGet(endpoints.GET_RENEWAL_NOTIFICATION_ACCEPTED_USERS_GRID);
};

export const getRenewalNotificationAcceptedUsersGridDistinct = () => {
  return api.sendGet(
    endpoints.GET_RENEWAL_NOTIFICATION_ACCEPTED_USERS_GRID_DISTINCT
  );
};
